<template>
  <div>
    <div id="collection" class="container">
      <section>
        <div class="section-subBysusan">
          <div class="snapshot section-group" style="display: flex; flex-direction: column">
            <div class="form-box left" style="width: initial">
              <input class="form-label" v-model="title_key" :placeholder="$t('Album.collection.Bibsearch')" />
              <div class="form-button bw-5 ptrl-1 ml--5" @click="getAlbumPhoto">
                <img src="../../assets/images/album/number_bib.gif" data-toggle="tooltip" data-placement="top" title=""
                  :data-original-title="$t('Album.collection.Bibsearch')" />
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="pageInfo != null">
          <div class="col-12 col-md-3">
            <!-- 合集資料 -->
            <div class="collection-detail section-group">
              <div class="collection-cover">
                <img :src="pageInfo.sgL_ImageUrl" :alt="pageInfo.sgL_PhotoName" class="w-100" />
              </div>
              <div class="collection-title">{{ pageInfo.sgL_PhotoName }}</div>
              <dl>
                <dt class="mt-3">{{$t('Album.collection.Collectionintroduction')}}</dt>
                <dd>{{ pageInfo.sgL_Content }}</dd>
                <dt class="mt-3">{{$t('Album.collection.Lastupdatetime')}}</dt>
                <dd>{{ pageInfo.sgL_UpdateTimeF }}</dd>
              </dl>
            </div>
            <!-- ./合集資料 -->
          </div>
          <div class="col-12 col-md-9 pl-md-4">
            <!-- 合集相簿 -->
            <div class="collection-album-list section-group" v-if="pageData != null">
              <div class="row">
                <div class="col-6 col-md-4 col-lg-3" v-for="item in pageData">
                  <router-link :to="{
                    name: 'albumviewPhotostream',
                    query: { id: item.id },
                  }">
                    <singleCollectionVue :props_img="item.photoImage" :props_title="item.sgL_PG_CName"
                      :props_author="item.sgL_Mem_DisplayName" :props_date="item.sgL_PG_CAddTimerI"
                      :props_num="item.sgL_PG_CPhotoQuantityF"></singleCollectionVue>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- ./合集相簿 -->
          </div>
        </div>
        <div class="row">
          <div class="col page">
            <pagination v-if="pageData != null && pageData.length > 0" :currentPage="pageParams.currentPage"
              :total="pageParams.total" :limit="pageParams.limit" :small="true" :hide-on-single-page="true"
              :pageSizes="pageParams.pageSizes" @handleCurrentChange="handleCurrent" @handleSizeChange="handleSize" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import singleCollectionVue from "./singleCollection.vue";
import pagination from "../common/Page";
export default {
  components: {
    singleCollectionVue,
    pagination,
  },
  data() {
    return {
      pageData: [],
      pageInfo: null,
      title_key: "",
      pageParams: {
        currentPage: 1,
        limit: 6,
        total: 0,
        pageSizes: [3, 6, 12, 24],
      },
    };
  },
  watch: {
    "pageInfo.sgL_PhotoName": {
      handler: function (newval, oldval) {
        let msg = newval + " - 尋寶網";
        document.title = msg;
        this.metaSet(msg);
      },
    },
  },
  created() {
    this.urlCheck();
    this.getPageData();
  },
  methods: {
    urlCheck() {
      if (this.$route.query.currentPage) {
        this.pageParams.currentPage = Number(this.$route.query.currentPage);
      }
      if (this.$route.query.currentSize) {
        this.pageParams.limit = Number(this.$route.query.currentSize);
      }
    },
    metaSet(ogtitle) {
      let head = document.getElementsByTagName("head");
      let meta = document.createElement("meta");
      let initMeta = {
        ogtitle,
      };
      document
        .querySelector('meta[name="ogtitle"]')
        .setAttribute("content", ogtitle);
      meta.content = initMeta;
      head[0].appendChild(meta);
    },
    getPageData() {
      if (this.$route.query && this.$route.query.id) {
        let params = {
          Id: this.$route.query.id,
          SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
          MaxResultCount: this.pageParams.limit,
        };
        this.$api.albumApi.PhotoCollectionGetDtl(params).then((res) => {
          if (res.data.success) {
            this.pageData = res.data.result.photo.items;
            this.pageParams.total = res.data.result.photo.totalCount;
            this.pageInfo = res.data.result;
          } else {
            this.$message({ type: "error", message: res.data.error.message });
          }
        });
      }
    },
    handleCurrent(val) {
      this.pageParams.currentPage = val;
      this.getPageData();
      this.pageRemeber();
    },
    handleSize(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getPageData();
      this.pageRemeber();
    },
    pageRemeber() {
      this.historyPushState(
        this.setUrlPar({
          currentPage: this.pageParams.currentPage,
          currentSize: this.pageParams.limit,
        })
      );
      window.scrollTo(0, 0);
    },
    getAlbumPhoto() {
      this.$router.push({
        name: "albumviewPhoto",
        query: { title: this.title_key, id: this.$route.query.id }
      });
    },
  },
};
</script>

<style scoped>
.page>>>.el-pagination__total {
  color: initial !important;
}

.page>>>.el-pagination__jump {
  color: initial !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Album/collection.vue